var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svg1074",
    clipPath: "url(#clip0_4453_17058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4453_17058",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1086",
    d: "M0 3.8147e-06H38V38H0V3.8147e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4453_17058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1092",
    d: "M10.9078 27.761L7.05128 29.9875C5.63133 30.8073 3.81564 30.3208 2.99582 28.9009L1.51144 26.3299C0.691773 24.9099 1.1782 23.0943 2.59816 22.2745L6.45464 20.0479L10.9078 27.761Z",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1096",
    d: "M10.9082 27.7617L24.7044 24.9385L15.7981 9.51244L6.45508 20.0487L10.9082 27.7617Z",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1100",
    d: "M13.4324 36.588C12.3674 37.2029 11.0057 36.838 10.3909 35.7731L7.05103 29.9883L10.9074 27.7617L14.2473 33.5465C14.8623 34.6114 14.4973 35.9732 13.4324 36.588Z",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1104",
    d: "M25.26 25.9023L15.2405 8.548",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1108",
    d: "M31.3203 10.0195H29.0938",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1112",
    d: "M31.3203 5.56641H29.0938",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1116",
    d: "M33.1758 19.2227H27.0898L29.6424 21.7985C29.5275 22.1563 29.4648 22.5376 29.4648 22.9336C29.4648 24.9831 31.1263 26.6445 33.1758 26.6445C35.2253 26.6445 36.8867 24.9831 36.8867 22.9336C36.8867 20.8841 35.2253 19.2227 33.1758 19.2227Z",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1120",
    d: "M30.207 1.11328C26.518 1.11328 23.5273 4.10385 23.5273 7.79297C23.5273 9.16082 23.9388 10.4324 24.6443 11.4914L23.8984 14.1016L26.5087 13.3557C27.5676 14.0612 28.8392 14.4727 30.207 14.4727C33.8961 14.4727 36.8867 11.4821 36.8867 7.79297C36.8867 4.10385 33.8961 1.11328 30.207 1.11328Z",
    stroke: "#D2042D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_17058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.a73460a23c6177e49425469bafee83e0.svg";
export { ForwardRef as ReactComponent };